import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import Placeholder from 'components/consumer/Placeholder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import BrowserOnly from 'components/consumer/BrowserOnly';
import avo from 'analytics/avo';
const PDPFinancingUI = t0 => {
  const $ = _c(12);
  const {
    affirmButtonRef,
    isFinancingModalLoading: t1,
    loading,
    numberOfMonths,
    onFinancingClick,
    pdpIsModularBYOProduct: t2,
    perMonthAmount,
    price
  } = t0;
  const isFinancingModalLoading = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const currentPage = useUserCurrentPageType();
  let t3;
  if ($[0] !== currentPage || $[1] !== onFinancingClick) {
    t3 = () => {
      avo.ctaClicked({
        text: "Learn more",
        targetUrl: "modal",
        cta: avo.Cta.FINANCING,
        component: avo.Component.PRODUCT_CARD,
        location: currentPage
      });
      onFinancingClick();
    };
    $[0] = currentPage;
    $[1] = onFinancingClick;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const financingLearnMoreOnClick = t3;
  if (loading) {
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="flex mt-1 lg:mt-1.5 !w-full lg:!w-[310px]"><Placeholder type="rect" loading={true} className="rounded-sm min-h-[12px]" style={{
          height: "23px",
          marginRight: "0"
        }} /></div>;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t4;
  if ($[4] !== affirmButtonRef || $[5] !== financingLearnMoreOnClick || $[6] !== isFinancingModalLoading || $[7] !== numberOfMonths || $[8] !== pdpIsModularBYOProduct || $[9] !== perMonthAmount || $[10] !== price) {
    t4 = <div className="flex mt-1 lg:mt-1.5 min-w-max">{pdpIsModularBYOProduct && !price ? <span className="text-xs flex text-gray mt-0 mr-2 mb-0 ml-0 whitespace-nowrap">Start adding pieces to calculate price + financing options</span> : <BrowserOnly><span className="text-xs flex text-gray mt-0 mr-2 mb-0 ml-0 whitespace-nowrap">{`From $${perMonthAmount}/mo for ${numberOfMonths} months at 0% APR `}</span><CtaButton aria-busy={isFinancingModalLoading} aria-label="Learn more about monthly payments" className="hover:underline" color="brand" disabled={isFinancingModalLoading} hasArrow={false} noLinkPadding={true} onClick={financingLearnMoreOnClick} size="xs" styling="link" type="button">{isFinancingModalLoading ? "Loading\u2026" : "Learn more"}</CtaButton><div style={{
          display: "none"
        }}><div type="button" ref={affirmButtonRef} className="affirm-as-low-as" data-page-type="product" data-amount={(price * 100).toString()}>Apply Now</div></div></BrowserOnly>}</div>;
    $[4] = affirmButtonRef;
    $[5] = financingLearnMoreOnClick;
    $[6] = isFinancingModalLoading;
    $[7] = numberOfMonths;
    $[8] = pdpIsModularBYOProduct;
    $[9] = perMonthAmount;
    $[10] = price;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
PDPFinancingUI.propTypes = {
  affirmButtonRef: PropTypes.object,
  loading: PropTypes.bool,
  numberOfMonths: PropTypes.number,
  onFinancingClick: PropTypes.func,
  pdpIsModularBYOProduct: PropTypes.bool,
  isFinancingModalLoading: PropTypes.bool,
  perMonthAmount: PropTypes.number,
  price: PropTypes.number
};
export default PDPFinancingUI;